import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import { slideFragment } from '@schema/slide'
import MajorEventsLanding from './major-events-landing'

const QUERY = gql`
query MajorEventsLandingPage($preview: Boolean)  {
  majorEventsLandingCollection(limit: 1, preview: $preview)  {
    items {
      headline
      heroImage {
        url
      }
      featuredEvent {
        __typename
				headline
        startDate
        endDate
        slug
        image {
          url
        }
      }
      eventCategoriesCollection {
        total
        items {
          title
          name
        }
      }
      showcaseEventHeadline
      showcaseEvent {
				headline
        course
        location
        startDate
        endDate
        slug
        logo {
          url
        }
        image {
          url
        }
      }
      ctaBoxesCollection(limit: 2) {
        items {
          ${slideFragment}
        }
      }
      metaTitle
      metaDescription
      metaImage {
        url
      }
    }
  }
}
`

export default function MajorEventsLandingWithData(props) {
  const { query } = props
  return (
    <Query query={QUERY} variables={query}>
      {({ loading, error, data }) => {
        if (error) return <Error error={error} displayErrorType="page" />
        if (loading) return <LinearProgress color="secondary" />

        const response = data.majorEventsLandingCollection
          && data.majorEventsLandingCollection.items[0]

        return response ? (
          <MajorEventsLanding {...response} {...props} />
        ) : (
          <Error statusCode={404} />
        )
      }}
    </Query>
  )
}

MajorEventsLandingWithData.propTypes = {
  query: PropTypes.object,
}
